<template>
  <CRow>
    <CCol sm="6" lg="3">
      <CWidgetDropdown color="primary" text="graph shows last 7 days avg rating" :header="rating">
        <!-- <template #default>
          <CDropdown color="transparent p-0" placement="bottom-end">
            <template #toggler-content>
              <CIcon name="cil-settings" />
            </template>
            <CDropdownItem>Action</CDropdownItem>
            <CDropdownItem>Another action</CDropdownItem>
            <CDropdownItem>Something else here...</CDropdownItem>
            <CDropdownItem disabled>Disabled action</CDropdownItem>
          </CDropdown>
        </template>-->
        <template #footer>
          <CChartLineSimple
            pointed
            class="mt-3 mx-3"
            style="height:70px"
            :data-points="[65, 59, 84, 84, 51, 55, 40]"
            point-hover-background-color="primary"
            label="Members"
            labels="months"
          />
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown color="info" text="graph shows last 7 days avg reviews" :header="reviews">
        <!-- <template #default>
          <CDropdown color="transparent p-0" placement="bottom-end" :caret="false">
            <template #toggler-content>
              <CIcon name="cil-location-pin" />
            </template>
            <CDropdownItem>Action</CDropdownItem>
            <CDropdownItem>Another action</CDropdownItem>
            <CDropdownItem>Something else here...</CDropdownItem>
            <CDropdownItem disabled>Disabled action</CDropdownItem>
          </CDropdown>
        </template>-->
        <template #footer>
          <CChartLineSimple
            pointed
            class="mt-3 mx-3"
            style="height:70px"
            :data-points="[1, 18, 9, 17, 34, 22, 11]"
            point-hover-background-color="info"
            :options="{ elements: { line: { tension: 0.00001 }}}"
            label="Members"
            labels="months"
          />
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown
        color="warning"
        text="graph shows last 7 days avg comments"
        :header="comments"
      >
        <!-- <template #default>
          <CDropdown color="transparent p-0" placement="bottom-end">
            <template #toggler-content>
              <CIcon name="cil-settings" />
            </template>
            <CDropdownItem>Action</CDropdownItem>
            <CDropdownItem>Another action</CDropdownItem>
            <CDropdownItem>Something else here...</CDropdownItem>
            <CDropdownItem disabled>Disabled action</CDropdownItem>
          </CDropdown>
        </template>-->
        <template #footer>
          <CChartLineSimple
            class="mt-3"
            style="height:70px"
            background-color="rgba(255,255,255,.2)"
            :data-points="[78, 81, 80, 45, 34, 12, 40]"
            :options="{ elements: { line: { borderWidth: 2.5 }}}"
            point-hover-background-color="warning"
            label="Members"
            labels="months"
          />
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown
        color="danger"
        text="graph shows Monthly Rating"
        :header="monthly_Rating"
        class="pt-1"
        style="height:160px"

      >
        <!-- <template #default>
          <CDropdown color="transparent p-0" placement="bottom-end" >
            <template #toggler-content>
              <CIcon name="cil-settings" />
            </template>
            <CDropdownItem>Action</CDropdownItem>
            <CDropdownItem>Another action</CDropdownItem>
            <CDropdownItem>Something else here...</CDropdownItem>
            <CDropdownItem disabled>Disabled action</CDropdownItem>
          </CDropdown>
        </template>-->
        <template #footer>
          <CChartBarSimple
            class="mt-4 mx-3"
            style="height:70px"
            background-color="rgb(250, 152, 152)"
            label="Members"
            labels="months"
          />
        </template>
      </CWidgetDropdown>
    </CCol>
  </CRow>
</template>

<script>
import { CChartLineSimple, CChartBarSimple } from "../charts/index.js";

export default {
  name: "WidgetsDropdown",
  components: { CChartLineSimple, CChartBarSimple },
  data() {
    return {
      rating: "Avg Rating" + " - " + this.value1,
      reviews: "Reviews" + " - " + this.value2,
      comments: "Comments" + " - " + this.value3,
      monthly_Rating: "Monthly Rating" + "-" + this.value4,
      // month_data : this.value5,
      // week_data : this.value6,
    };
  },
  computed(){
      // ...mapState(['value1'])

  },
  watch: {
    updateData: {
      handler: function (value1) {
        // check someData and eventually call
        this.value1= value1
        console.log("value1" , value1);
      },
    }
  },
  mounted() {
    console.log("this.rating,", this.value1,this.value2,this.value3,this.value4);
  },
  props: {
    value1: String,

    value2: String,
    value3: String ,
    value4: String,
    value5: Array,
    value6: Array,
  },
};
</script>
